import { useEffect } from 'react';

interface UseFreelancerExpansionProps {
  selectedFreelancersForInvoice: any[];
  expandedSections: { [key: string]: boolean };
  setExpandedSections: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>;
}

export const useFreelancerExpansion = ({
  selectedFreelancersForInvoice,
  expandedSections,
  setExpandedSections,
}: UseFreelancerExpansionProps) => {
  
  useEffect(() => {
    if (selectedFreelancersForInvoice.length > 0) {
      const allExpandedState: { [key: string]: boolean } = {};
      selectedFreelancersForInvoice.forEach((friend: any, index: number) => {
        const friendUserID = friend.userId || 0;
        if (expandedSections[friendUserID] === undefined) {
          allExpandedState[friendUserID] = true;
        } else {
          allExpandedState[friendUserID] = expandedSections[friendUserID];
        }
      });
      setExpandedSections(allExpandedState);
    }
  }, [selectedFreelancersForInvoice]);
};
